'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import ScrollReveal from 'scrollreveal';

var Animations = exports.Animations = function Animations() {
  var fadeIn = {
    viewFactor: 0.4,
    duration: 1200,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };
  var fadeInFirst = {
    duration: 1200,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInLeft = {
    viewFactor: 0.4,
    origin: 'left',
    distance: '10%',
    duration: 1000,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInRight = {
    viewFactor: 0.4,
    origin: 'right',
    distance: '10%',
    duration: 1000,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInUp = {
    viewFactor: 0.4,
    origin: 'bottom',
    distance: '10%',
    duration: 1000,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInScale = {
    viewFactor: 0.3,
    scale: 0.95,
    duration: 1200,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInScaleDown = {
    viewFactor: 0.3,
    scale: 1.1,
    duration: 1200,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInFromLeft1 = {
    origin: 'left',
    distance: '20%',
    duration: 1000,
    // mobile: false,
    viewFactor: 0.5,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInFromLeft2 = {
    delay: 150,
    origin: 'left',
    distance: '50%',
    duration: 1200,
    // mobile: false,
    viewFactor: 0.5,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  var fadeInFromLeft3 = {
    delay: 300,
    origin: 'left',
    distance: '100%',
    duration: 1400,
    // mobile: false,
    viewFactor: 0.5,
    easing: 'cubic-bezier(.39,.575,.565,1)'
  };

  ScrollReveal().reveal('.product-card--1', fadeInFromLeft1);
  ScrollReveal().reveal('.product-card--2', fadeInFromLeft2);
  ScrollReveal().reveal('.product-card--3', fadeInFromLeft3);
  ScrollReveal().reveal('.fadeIn', fadeIn);
  ScrollReveal().reveal('.fadeInFirst', fadeInFirst);
  ScrollReveal().reveal('.fadeInLeft', fadeInLeft);
  ScrollReveal().reveal('.fadeInRight', fadeInRight);
  ScrollReveal().reveal('.fadeInUp', fadeInUp);
  ScrollReveal().reveal('.fadeInScale', fadeInScale);
  ScrollReveal().reveal('.fadeInScaleDown', fadeInScaleDown);
};